import { LoadingSpinner } from '@carlito/dashboard-ui';
import classnames from 'classnames';
import { ComponentProps, useEffect } from 'react';
import AnimatedSuccessCheckmark from './AnimatedSuccessCheckmark';

interface Props extends ComponentProps<'button'> {
  loading?: boolean;
  success?: boolean;
  onSuccessAnimationEnd?: () => void;
}

const FormSubmitButton = ({
  className,
  success,
  loading,
  disabled,
  children,
  onSuccessAnimationEnd,
  ...btnProps
}: Props) => {
  useEffect(() => {
    if (success) {
      const timeout = setTimeout(() => {
        onSuccessAnimationEnd?.();
      }, 2000);
      return () => clearTimeout(timeout);
    }

    return undefined;
  }, [success, onSuccessAnimationEnd]);

  return (
    <div className="relative">
      {success && <AnimatedSuccessCheckmark className="absolute left-2 top-2" />}
      <button
        type="submit"
        id="product-tour-save"
        disabled={loading || disabled}
        className={classnames(
          className,
          { 'bg-gray-300': disabled },
          {
            'bg-primary-default hover:bg-primary-tint focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-default':
              !disabled,
          },
          { 'cursor-not-allowed': loading },
          'w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-3xl shadow-sm text-lg font-extrabold text-primary-contrast'
        )}
        {...btnProps}
      >
        <div className="w-0">{loading && <LoadingSpinner className="h-5 w-5" />}</div>
        <div className="w-full pl-3">{children}</div>
      </button>
    </div>
  );
};

export default FormSubmitButton;
